export default "__VITE_ASSET__DgQonU4H__"